<template>
	<div>
		<v-menu offset-overflow offset-y bottom max-height="300px" :close-on-content-click="false">
			<template v-slot:activator="{ on }">
				<v-chip
					:outlined="itemsSelected.length === 0"
					filter
					:color="itemsSelected.length > 0 ? 'rgba(231, 152, 49, 0.1)' : ''"
					:text-color="itemsSelected.length > 0 ? '#E79831' : ''"
					:close="itemsSelected.length > 0"
					@click:close="clearFilter()"
					v-on="on"
				>
					{{ itemsSelected.length > 0 ? itemsSelected[0].name : ''}}
					<span
						v-if="itemsSelected.length > 1"
						style="margin-left: 5px;"
					>+{{ itemsSelected.length - 1 }}</span>
					<span v-if="itemsSelected.length === 0">
						{{placeholder}}
						<v-icon right>mdi-menu-down</v-icon>
					</span>
				</v-chip>
			</template>
			<v-list dense>
				<v-list-item v-for="(item, index) in items" :key="index">
					<v-checkbox
						color="primary"
						:label="item.name"
						:value="item"
						:ripple="false"
						v-model="itemsSelected"
						dense
					></v-checkbox>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>


<script>
export default {
	name: "SelectInput",
	props: {
		items: Array,
		placeholder: String
	},
	data: () => {
		return {
			itemsSelected: []
		};
	},
	methods: {
		clearFilter() {
			this.itemsSelected = [];
		}
	},
	watch: {
		itemsSelected: function(newVal) {
			this.$emit("change", newVal);
		}
	}
};
</script>

<style lang="scss" scoped>
</style>


